import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cta',
  templateUrl: './cta.component.html',
  styleUrls: ['./cta.component.scss']
})

/**
 * Cta Component
 */
export class CtaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
